import React from 'react';
import { AircraftPart } from '../types/aircraft';
import './AircraftPartSelector.css';

interface AircraftPartSelectorProps {
  aircraftView: 'top' | 'front';
  selectedPartNames: string[]; // Изменено на массив
  onPartChange: (partNames: string[]) => void; // Изменено для работы с массивом
  aircraftParts: AircraftPart[];
}

const AircraftPartSelector: React.FC<AircraftPartSelectorProps> = ({
  aircraftView,
  selectedPartNames,
  onPartChange,
  aircraftParts
}) => {
  // Функция для получения частей самолета для текущего вида
  const getCurrentViewParts = () => {
    return aircraftParts.filter(part => part.view === aircraftView);
  };

  const handlePartToggle = (partName: string) => {
    const newSelectedParts = selectedPartNames.includes(partName)
      ? selectedPartNames.filter(name => name !== partName)
      : [...selectedPartNames, partName];
    
    onPartChange(newSelectedParts);
  };

  const handleSelectAll = () => {
    const currentViewParts = getCurrentViewParts();
    const allPartNames = currentViewParts.map(part => part.name);
    onPartChange(allPartNames);
  };

  const handleClearAll = () => {
    onPartChange([]);
  };

  return (
    <div className="aircraft-part-selector">
      <div className="selector-header">
        <label>Части самолета</label>
        <div className="selector-actions">
          <button
            type="button"
            className="select-all-btn"
            onClick={handleSelectAll}
          >
            Выбрать все
          </button>
          <button
            type="button"
            className="clear-all-btn"
            onClick={handleClearAll}
          >
            Очистить
          </button>
        </div>
      </div>
      
      <div className="parts-list">
        {getCurrentViewParts().map((part) => (
          <div key={part.id} className="part-item">
            <label className="part-checkbox">
              <input
                type="checkbox"
                checked={selectedPartNames.includes(part.name)}
                onChange={() => handlePartToggle(part.name)}
              />
              <span className="checkmark"></span>
              <span className="part-name">{part.name}</span>
            </label>
          </div>
        ))}
      </div>
      
      {selectedPartNames.length > 0 && (
        <div className="selected-parts-info">
          Выбрано: {selectedPartNames.length} из {getCurrentViewParts().length}
        </div>
      )}
    </div>
  );
};

export default AircraftPartSelector; 